import {useState, useEffect, useRef} from "react"
import createReactClass from "create-react-class"
import GoogleLogin from "react-google-login"
import {getMetaContentByName} from "util/env"
import assign from "object-assign"
import GoogleSVG from "../../images/google-favicon.svg?react"
import CleverSVG from "../../images/clever-favicon.svg?react"
import ClassLinkSVG from "../../images/classlink-favicon.svg?react"
import {Button} from "../components/buttons"

const clientId = getMetaContentByName("google-signin-client_id")
const cleverClientId = getMetaContentByName("clever-client-id")
const cleverRedirectUri = getMetaContentByName("clever-redirect-uri")
const classLinkClientId = getMetaContentByName("classlink-client-id")
const classLinkRedirectUri = getMetaContentByName("classlink-redirect-uri")

const getDetails = (action) => {
  switch (action) {
    case "login":
      return {
        route: "/api4/oauth/google/login",
        text: "signin"
      }
    case "convert":
      return {
        route: "/api4/oauth/google/convert",
        text: "use"
      }
    default:
      return {
        route: "/api4/oauth/google/continue",
        text: "signup"
      }
  }
}

export const ContinueWithGoogle = ({actionType, paramString, userType, klassCode, birthdate, subdomain}) => {
  const {route, text} = getDetails(actionType)
  const [id_token, setIdToken] = useState(null)
  const formRef = useRef(null)

  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://accounts.google.com/gsi/client"
    script.async = true
    script.defer = true
    document.head.appendChild(script)
    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: handleCredentialResponse
      })

      window.google.accounts.id.renderButton(document.getElementById("google-button"), {
        size: "large",
        theme: "outline",
        type: "standard",
        shape: "pill",
        context: text,
        logo_alignment: "center",
        width: document.getElementById("google-button").offsetWidth
      })
    }
  }, [])

  useEffect(() => {
    if (id_token) {
      formRef.current.submit()
    }
  }, [id_token])

  const handleCredentialResponse = (response) => {
    setIdToken(response.credential)
  }

  return (
    <div className="google max-w-[400px] mx-auto w-full flex justify-center">
      <form method="POST" action={`${route}${paramString || ""}`} hidden={true} ref={formRef}>
        <input type="hidden" name="id_token" value={id_token || ""} />
        <input type="hidden" name="type" value={userType || ""} />
        <input type="hidden" name="code" value={klassCode || ""} />
        <input type="hidden" name="birthdate" value={birthdate || ""} />
        <input type="hidden" name="subdomain" value={subdomain || ""} />
      </form>

      <div id="google-button" style={{width: "100%", height: "100%", minWidth: "100%"}}></div>
    </div>
  )
}

const btnText = {
  signup: "Sign Up with Clever",
  login: "Log In with Clever"
}

const classLinkBtnText = {
  signup: "Sign Up with ClassLink",
  login: "Log In with ClassLink"
}

const btnClsByStyle = {
  auth: "w-full !py-1.5 min-h-10 border-[1px]",
  default: ""
}

export const CleverLoginButton = ({btnStyle = "default", actionType, disabled, state}) => (
  <Button
    className={btnClsByStyle[btnStyle]}
    disabled={disabled}
    href={`https://clever.com/oauth/authorize?response_type=code&redirect_uri=${cleverRedirectUri}&client_id=${cleverClientId}&state=${state}`}
  >
    <div className="flex items-center gap-x-3" style={disabled ? {opacity: "0.6"} : {}}>
      <CleverSVG />
      <span className="body-sm text-xs leading-none">{btnText[actionType]}</span>
    </div>
  </Button>
)

export const ClassLinkLoginButton = ({btnStyle = "default", actionType, disabled, state}) => (
  <Button
    className={btnClsByStyle[btnStyle]}
    disabled={disabled}
    href={`https://launchpad.classlink.com/oauth2/v2/auth?response_type=code&redirect_uri=${classLinkRedirectUri}&client_id=${classLinkClientId}&scope=profile&state=${state || ""}`}
  >
    <div className="flex items-center gap-x-3" style={disabled ? {opacity: "0.6"} : {}}>
      <ClassLinkSVG />
      <span className="body-sm text-xs leading-none">{classLinkBtnText[actionType]}</span>
    </div>
  </Button>
)

export const ContinueWithClever = (props) => (
  <div className="max-w-[400px] mx-auto w-full">
    <CleverLoginButton {...props} btnStyle="auth" />
  </div>
)

export const ContinueWithClassLink = (props) => (
  <div className="max-w-[400px] mx-auto w-full">
    <ClassLinkLoginButton {...props} btnStyle="auth" />
  </div>
)
